import type {
  BrandProfitAndRevenueSummaryQuery,
  BrandProfitAndRevenueTableDataQuery,
} from "@src/__generated__/urql-graphql";
import { action, makeObservable, observable } from "mobx";
import { createContext, useContext } from "react";
import { BrandReportStore } from "../../common/store";
import { BrandProfitAndRevenueModel } from "../models";

export const StoreContext = createContext({} as Store);
export const useStore = () => useContext(StoreContext);

export class Store {
  readonly key = "brandRevenueAndProfit";
  reportStore: BrandReportStore;
  @observable brands: BrandProfitAndRevenueModel[] = [];
  @observable
  summary?: BrandProfitAndRevenueSummaryQuery["brandRevenueSummary"];

  constructor() {
    makeObservable(this);
    this.reportStore = new BrandReportStore(this.key);
  }

  @action setTableData(query: BrandProfitAndRevenueTableDataQuery) {
    this.brands = query.brandRevenue.result.map(
      (i) => new BrandProfitAndRevenueModel(i),
    );
    this.reportStore.setExpenseBudgetCategories(
      query?.expenseBudgetCategories ?? [],
    );

    if (query.brandRevenue.paginatorInfo) {
      this.reportStore.pagination.setFromPaginatorInfo(
        query.brandRevenue.paginatorInfo,
      );
    }
  }

  @action setSummary(query: BrandProfitAndRevenueSummaryQuery) {
    this.summary = query.brandRevenueSummary;
  }
}
